<script lang="ts">
  import type { Snippet } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import Icon from '../shared/components/Icon.svelte';
  import { settings } from '../shared/lib/settings.svelte';

  let { title, onclose, children }: { title: string; onclose: () => void; children: Snippet } =
    $props();

  const d = $derived(settings.reducedMotion ? 0 : 1);
  const wide = typeof matchMedia === 'function' && matchMedia('(min-width: 860px)').matches;
</script>

<svelte:window onkeydown={(e) => e.key === 'Escape' && onclose()} />

<div
  class="scrim"
  data-ui
  transition:fade={{ duration: 200 * d }}
  onclick={onclose}
  aria-hidden="true"
></div>
<div
  class="sheet"
  data-ui
  role="dialog"
  aria-modal="true"
  aria-label={title}
  transition:fly={wide
    ? { x: 48, duration: 320 * d, opacity: 0 }
    : { y: 64, duration: 320 * d, opacity: 0 }}
>
  <header>
    <h2>{title}</h2>
    <button class="close" onclick={onclose} aria-label="Close"><Icon name="close" /></button>
  </header>
  <div class="content">{@render children()}</div>
</div>

<style>
  .scrim {
    position: fixed;
    inset: 0;
    z-index: 40;
    background: color-mix(in srgb, var(--bg-sunken) 55%, transparent);
  }

  .sheet {
    position: fixed;
    z-index: 41;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: min(82dvh, 760px);
    display: flex;
    flex-direction: column;
    background: var(--bg);
    border-top: 1px solid var(--line);
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -18px 40px -24px rgb(0 0 0 / 0.4);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  @media (min-width: 860px) {
    .sheet {
      left: auto;
      top: 0;
      width: 440px;
      max-height: none;
      border-top: 0;
      border-left: 1px solid var(--line);
      border-radius: 0;
    }
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 16px 8px 20px;
  }
  h2 {
    font-size: var(--text-lg);
  }
  .close {
    width: 40px;
    height: 40px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: var(--ink-2);
  }
  .content {
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  /* Views reused from V2 bring their own page padding; trim it inside a sheet. */
  .content :global(.view) {
    padding-top: 0;
    padding-bottom: var(--space-6);
  }
  .content :global(.view-head h1) {
    display: none;
  }
</style>
